<template>
  <div
    :class="[
      'bg-white rounded-borders-lg',
      { 'cursor-pointer': !disable && !loading }
    ]"
    :style="{ width: width, 'min-width': width }"
    @click="click"
  >
    <div v-if="loading" class="row justify-center q-pa-lg">
      <SAISpinner class="q-mx-lg" />
    </div>
    <div v-else-if="error" class="row col">
      <div class="q-py-lg q-pl-lg col">
        <p class="text-weight-bold q-mb-sm">
          Sorry, we are having issues getting your quote
        </p>
        <span class="text-weight-medium text-tab">
          Please call our team on
          <SAILink
            :href="`tel:${errorContactNumber}`"
            target="_blank"
            class="whitespace-no-wrap"
          >
            {{ errorContactNumber }}
          </SAILink>
          or try refreshing your browser.
        </span>
      </div>
      <div class="row items-end" v-if="errorImg">
        <img
          :src="errorImg"
          alt="vehicle error img"
          :style="{ width: errorImgWidth }"
          class="q-pr-sm"
        />
      </div>
    </div>
    <div v-else class="select-none q-pa-lg">
      <div class="row q-mb-md items-start justify-between">
        <div :class="['col q-mr-sm', { 'text-ellipsis': descriptionEllipsis }]">
          <span class="text-weight-bold text-grey-10" :title="title">
            {{ title }}
          </span>
          <div class="inline">
            <span class="text-grey-6 text-tab" v-if="kmsPerYear">
              {{ kmsPerYear }}km
            </span>
            <span
              class="text-grey-6 text-tab q-mx-xs"
              v-if="kmsPerYear && leaseTerm"
            >
              /
            </span>
            <span class="text-grey-6 text-tab" v-if="leaseTerm">
              {{ leaseTerm }} months
            </span>
          </div>
        </div>
        <SAIChip
          v-if="tag"
          :color="`${tagColor}-pale`"
          :text-color="tagColor"
          :label="tag"
          class="q-ma-none"
        />
      </div>

      <div :class="['row', { 'no-wrap whitespace-no-wrap': !wrap }]">
        <img
          v-if="img"
          :src="img"
          alt="Quote Vehicle"
          class="q-mr-md image-contain"
          :style="{ width: imgWidth }"
        />
        <div class="col column">
          <p v-if="reference" class="text-grey-8 text-weight-bold q-mb-xs">
            Quote #{{ reference }}
          </p>
          <div v-if="cost">
            <p class="text-primary text-weight-bold text-h4 q-mb-xs word-break">
              {{
                cost | frequency(costFromFrequency, costToFrequency) | currency
              }}/{{ toFrequencyCharacter }}
            </p>
            <span class="text-tab">Net impact on take home pay</span>
          </div>
          <p class="text-grey-6 text-weight-medium" v-else>{{ noCostText }}</p>
          <QSpace />
          <div class="row justify-between items-center q-mt-xs" v-if="!disable">
            <p class="text-primary text-weight-medium">{{ nextText }}</p>
            <QIcon name="eva-arrow-forward" color="primary" size="24px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SAISpinner from '../../atom/sai-spinner';
import SAILink from '../../atom/sai-link';
import SAIChip from '../../atom/sai-chip';
import { CALCULATION_FREQUENCIES } from '../../../utils/payment-frequency-converter';
import frequency from '../../../filters/frequency';
import { QIcon, QSpace } from 'quasar';

export default {
  name: 'SAIQuoteCard',
  data() {
    return {
      frequencies: CALCULATION_FREQUENCIES
    };
  },
  props: {
    error: Boolean,
    errorContactNumber: String,
    errorImg: String,
    errorImgWidth: {
      type: String,
      default: '118px'
    },
    loading: Boolean,
    disable: Boolean,
    wrap: {
      type: Boolean,
      default: true
    },
    reference: String,
    kmsPerYear: Number,
    leaseTerm: Number,
    cost: Number,
    costFromFrequency: {
      type: String,
      default: 'monthly'
    },
    costToFrequency: {
      type: String,
      default: 'weekly'
    },
    noCostText: {
      type: String,
      default: 'Our team is currently fetching your quote'
    },
    img: String,
    imgWidth: {
      type: String,
      default: '140px'
    },
    title: String,
    width: String,
    nextText: {
      type: String,
      default: 'Next'
    },
    tag: String,
    tagColor: {
      type: String,
      default: 'primary'
    },
    descriptionEllipsis: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    toFrequencyCharacter() {
      return CALCULATION_FREQUENCIES.hasOwnProperty(this.costToFrequency)
        ? CALCULATION_FREQUENCIES[this.costToFrequency].character
        : undefined;
    }
  },
  methods: {
    click() {
      if (!this.disable && !this.loading) {
        this.$emit('click');
      }
    }
  },
  filters: {
    frequency
  },
  components: {
    SAISpinner,
    QIcon,
    QSpace,
    SAIChip,
    SAILink
  }
};
</script>
